import { commonRowAndCellClassRules } from '_legacy/components/grid/classRules/classRules';
import defaultObjEquals from '_legacy/components/grid/columnDefaults/defaultObjEquals';
import DateComparator from '_legacy/components/grid/comparators/DateComparator';
import DateEditor from '_legacy/components/grid/editors/DateEditor';
import DefaultDateFormatter from '_legacy/components/grid/formatters/DefaultDateFormatter';
import { isEditableRow } from '_legacy/modules/shared/columns/tools/headingTools';

export const isReportedDateValid = (
    value: string | null | undefined
): boolean => {
    return !!value && !isNaN(Date.parse(value));
};

export const reportedDateHeading = {
    colId: 'reportedDate',
    headerName: 'Rptd Date',
    field: 'reportedDate',
    valueFormatter: DefaultDateFormatter,
    cellEditorFramework: DateEditor,
    editable: isEditableRow,
    equals: defaultObjEquals,
    comparator: DateComparator,
    type: ['privatable'],
    excelExportFormat: 'date',
    cellClassRules: {
        ...commonRowAndCellClassRules,
    },
    filter: 'reportedDateFilter',
    width: 85,
};
